import angular from '../../assets/consultingSection/angular.svg'
import blockchain from '../../assets/consultingSection/blockchain.svg'
import cyber from '../../assets/consultingSection/cyber.svg'
import elixir from '../../assets/consultingSection/elixir.svg'
import jango from '../../assets/consultingSection/jango.svg'
import laravel from '../../assets/consultingSection/laravel.svg'
import mobile from '../../assets/consultingSection/mobile.svg'
import net from '../../assets/consultingSection/net.svg'
import nodejs from '../../assets/consultingSection/nodejs.svg'
import python from '../../assets/consultingSection/python.svg'
import react from '../../assets/consultingSection/react.svg'
import ruby from '../../assets/consultingSection/ruby.svg'
import web from '../../assets/consultingSection/website.svg'
import software from '../../assets/consultingSection/GAME.svg'

import swift from '../../assets/consultingSection/swift.svg'
import ionic from '../../assets/consultingSection/ionic.svg'
import Kotlin from '../../assets/consultingSection/Kotlin.svg'
import Objective from '../../assets/consultingSection/Objective-C.svg'

import celo from '../../assets/consultingSection/celo.svg'
import solana from '../../assets/consultingSection/solana.svg'
import algorand from '../../assets/consultingSection/algorand.svg'
import cosmos from '../../assets/consultingSection/cosmos.svg'
import palkadot from '../../assets/consultingSection/palkadot.svg'
import substrate from '../../assets/consultingSection/substrate.svg'
import cardano from '../../assets/consultingSection/cardano.svg'

import evil from '../../assets/consultingSection/evil.svg'
import frida from '../../assets/consultingSection/frida.svg'
import an from '../../assets/consultingSection/an.svg'
import nuclei from '../../assets/consultingSection/nuclei.svg'
import zap from '../../assets/consultingSection/zap.svg'

import s1 from '../../assets/consultingSection/s1.svg'
import s2 from '../../assets/consultingSection/s2.svg'
import s3 from '../../assets/consultingSection/s3.svg'
import s4 from '../../assets/consultingSection/s4.svg'
import s5 from '../../assets/consultingSection/s5.svg'
import s6 from '../../assets/consultingSection/s6.svg'
import s7 from '../../assets/consultingSection/s7.svg'
import s8 from '../../assets/consultingSection/s8.svg'


export const servicesName = [
    {
        title: 'Web App Development',
        img: web
    },
    {
        title: 'Cybersecurity',
        img: cyber
    },
    {
        title: 'Blockchain Development',
        img: blockchain
    },
    {
        title: 'Software Development and Consultation',
        img: software
    },
    {
        title: 'Mobile App Development',
        img: mobile
    },
]

export const SoftwareContent = {
    title: 'Software Development and Consultation',
    desc: 'Proficient IoT app developers to build world-class, scalable, and future-ready IoT applications.',
    icons: [
        s1,
        s2,
        s3,
        s4,
        s5,
        s6,
        s7,
        s8,
    ],
    link: 'software-development-servicess'

}
export const CyberContent = {
    title: 'Cybersecurity',
    desc: 'Let’s eliminate vulnerabilities and fill loopholes to stop unforeseen cyberattacks with Codezone’s cover-all cybersecurity services. It’s an “evil genius vs. ethical genius war” — and we have got experience, years of it!',
    icons: [
        evil,
        frida,
        an,
        nuclei,
        zap
    ],
    link: 'cyber-security-services'

}
export const BlockChainContent = {
    title: 'Blockchain Development',
    desc: 'Become a part of a trustless and borderless distributed network with InvoBlox’s real-world blockchain consultancy and development services.',
    icons: [
        celo,
        solana,
        algorand,
        cosmos,
        palkadot,
        substrate,
        cardano
    ],
    link: 'blockchain-development'

}
export const AppContent = {
    title: 'Mobile App Development',
    desc: 'Consultation on updating existing mobile applications and development of apps that look and perform great on both iOS and Android.',
    icons: [
        ionic,
        Kotlin,
        Objective,
        react,
        swift
    ],
    link: 'mobile-app-development-services'

}
export const webAppContent = {
    title: 'Web App Development',
    desc: 'Scalable web product development at any stage and ongoing support after launch.',
    icons: [
        angular,
        elixir,
        jango,
        laravel,
        net,
        nodejs,
        python,
        react,
        ruby
    ],
    link: 'web-app-development-services'

}


